export const orgAdminSelectedOrgIdLocalStorageKey =
  'embraceable-ai-selected-organisation-id';
